import ExternalLink from '@/components/elements/ExternalLink';

export default function TextAndButton({ block, position }) {
  const { preheading, heading, description, buttons, _metadata } =
    block.text_and_button;

  let titleStr1 = heading;
  let titleStr2 = '';
  let superscript = '';

  //if there is a superscript symbol, split it out from the rest of the text so that we can style it to be smaller
  if (heading?.length > 0) {
    if (heading?.includes('®')) {
      titleStr1 = heading.split('®')[0];
      titleStr2 = heading.split('®')[1];
      superscript = '®';
    } else if (heading?.includes('™')) {
      titleStr1 = heading.split('™')[0];
      titleStr2 = heading.split('™')[1];
      superscript = '™';
    } else if (heading?.includes('©')) {
      titleStr1 = heading.split('©')[0];
      titleStr2 = heading.split('©')[1];
      superscript = '©';
    }
  }

  return (
    <section
      id={_metadata.uid + '_' + position}
      data-name="text_and_button"
      className="text_and_button"
    >
      <div className="mx-auto max-w-[1360px] justify-between px-5 py-15 sm:flex sm:px-10 lg:px-20">
        <div className="max-w-[600px]">
          <div className="preheading-s text-burnt-cognac pb-4">
            {preheading}
          </div>
          {superscript?.length > 0 ? (
            <h1 className="h3 sm:h2 flex flex-wrap">
              <span className="block">{titleStr1}</span>
              {superscript?.length > 0 && (
                <span className="body-xs inline-block self-start pr-1">
                  {superscript}
                </span>
              )}
              <span className="block">{titleStr2}</span>
            </h1>
          ) : (
            <h1 className="h3 sm:h2">{heading}</h1>
          )}
          {description && (
            <p className="body-s sm:body-r pt-4">{description}</p>
          )}
        </div>
        <div className="flex gap-x-5 self-end pt-5 sm:pt-0">
          {buttons.map((button) => {
            return (
              <ExternalLink
                linkText={button.button_text}
                internalLink={button?.reference[0]?.url}
                linkStyling="btn btn-tertiary-dark px-5!"
                key={button._metadata.uid}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
}
